var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalksicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 22.9167L43.75 12.5V37.5L6.25 29.1667V22.9167Z",
    stroke: "#FBD050",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1664 35C23.9476 35.7934 23.5746 36.5359 23.0687 37.1851C22.5629 37.8344 21.9341 38.3777 21.2184 38.7839C20.5026 39.1902 19.7138 39.4515 18.897 39.5529C18.0802 39.6543 17.2515 39.5938 16.4581 39.375C15.6647 39.1561 14.9222 38.7831 14.2729 38.2773C13.6237 37.7714 13.0804 37.1427 12.6741 36.4269C12.2679 35.7111 12.0066 34.9223 11.9052 34.1055C11.8038 33.2888 11.8642 32.46 12.0831 31.6666",
    stroke: "#FBD050",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalksicon);
export default __webpack_public_path__ + "static/media/talks icon.7dd1c011f28e9c304dfe182f664f4e73.svg";
export { ForwardRef as ReactComponent };